import Card from 'components/common/Card';
import { BorderTheme, CardTheme } from 'components/common/Card/Card.types';
import infoSvg from 'assets/icons/info.svg';
import SvgIcon from 'lib/SvgIcon';
import Tooltip, { TooltipDirection } from 'lib/Tooltip';

import { INFO_TYPE, InfoMessageProps } from './InfoMessage.types';

const defaultIcon = <SvgIcon src={infoSvg} className="fill-current" />;

const InfoMessage = ({
  children = null,
  type = INFO_TYPE.CARD,
  icon = defaultIcon,
  direction = TooltipDirection.TOP,
  borderTheme = BorderTheme.BASIC,
  cardTheme = CardTheme.LIGHT,
}: InfoMessageProps): React.ReactElement => {
  if (type === INFO_TYPE.TOOLTIP) {
    return (
      <Tooltip tooltip={children} direction={direction}>
        {icon}
      </Tooltip>
    );
  }

  return (
    <Card borderTheme={borderTheme} cardTheme={cardTheme}>
      <div className="flex">
        <div className="pr-2">{icon}</div>
        <div className="body-base text-neutral-950-opacity-80">{children}</div>
      </div>
    </Card>
  );
};

export default InfoMessage;
